import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ScheduledBookingService {
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) {
    }

    getById(id: string): any {
        return this.http.get(`${this.url}/scheduledbooking/${id}`);
    }

    getAllByOrganizationId(filter): any {
        return this.http.post(`${this.url}/scheduledbookings/organization`, filter);
    }

    update(id: string, data): any {
        return this.http.post(`${this.url}/scheduledbooking/update/${id}`, data);
    }

    create(data): any {
        return this.http.post(`${this.url}/scheduledbooking/create`, data);
    }

    delete(data): any {
        return this.http.post(`${this.url}/scheduledbooking/delete`, data);
    }

    resendPaymentLink(data: any): any {
        return this.http.post(`${this.url}/scheduledbooking/resendpaymentlink`, data);
    }
}
